import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ButtonLink from '../../../common/buttons/ButtonLink'
import { displayWithCurrency } from '../../../../utility/currency'

import classes from './UnlockFamilyCard.module.scss'

const UnlockFamilyCard = ({ plan, upgrade, communityId }) => {
  const { t } = useTranslation()
  const tier = t(`programs.registration.membershipPlan.tiers.${plan.tier}`)

  return (
    <section className={classes.unlockFamilyCard}>
      <h4 className={classes.title}>{t('dashboard.student.accountTab.membership.unlockTitle')}</h4>
      <p className={classes.text}>
        {upgrade
          ? t('dashboard.student.accountTab.membership.unlockUpgrade', {
            tier, count: plan.seats, price: displayWithCurrency(plan.upgradeAmount, plan.currency),
          })
          : t('dashboard.student.accountTab.membership.unlockPurchase', {
            tier, count: plan.seats, price: displayWithCurrency(plan.amount, plan.currency),
          })}
      </p>
      <ButtonLink navigateTo={`/landing/${communityId}`} noTopMargin>
        {t('dashboard.student.accountTab.membership.joinProgram')}
      </ButtonLink>
    </section>
  )
}

UnlockFamilyCard.propTypes = {
  plan: PropTypes.shape({
    tier: PropTypes.string,
    seats: PropTypes.number,
    amount: PropTypes.number,
    upgradeAmount: PropTypes.number,
    currency: PropTypes.object,
  }).isRequired,
  upgrade: PropTypes.bool,
  communityId: PropTypes.number.isRequired,
}

export default UnlockFamilyCard
